var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-selection-container" }, [
    _c("p", { staticClass: "main-title" }, [
      _vm._v("Enter Recipient information")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "main-subtitle small" }, [
      _vm._v(
        "Ship in bulk to many people or just one. Enter their email address below or fill out the email address template for bulk shipments."
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "first-container" }, [
      _c("div", { staticClass: "product-container" }, [
        _c("div", { staticClass: "gift-container selected" }, [
          _c("img", {
            staticClass: "green-check",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
            }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "main-image lazyload",
            attrs: { src: _vm._f("getProductImage")(_vm.product) }
          }),
          _vm._v(" "),
          _vm.isBox
            ? _c("div", { staticClass: "item-box" }, [
                _c("img", {
                  staticClass: "box-image",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/emptybox_1.png?v=1659452617"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "addon-images" },
                  _vm._l(_vm.boxImages, function(image) {
                    return _c("img", {
                      key: image,
                      staticClass: "addon-image",
                      attrs: { src: image }
                    })
                  }),
                  0
                )
              ])
            : _c("img", {
                staticClass: "main-image lazyload",
                attrs: { src: _vm._f("getProductImage")(_vm.product) }
              }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.product.title))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-qty-container" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v("Enter Number of Recipients")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "qty-selector" }, [
          _c("img", {
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/personicon.svg?v=1674850316"
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailQty,
                expression: "emailQty"
              }
            ],
            attrs: { min: "1", type: "number" },
            domProps: { value: _vm.emailQty },
            on: {
              change: _vm.validateQty,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.emailQty = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        !_vm.didSubmit
          ? _c(
              "button",
              {
                staticClass: "happybox-button yellow",
                on: { click: _vm.submitEmailQty }
              },
              [_vm._v("Continue")]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.didSubmit
      ? _c("div", { staticClass: "email-container" }, [
          _vm.emailQty == 1
            ? _c("div", { staticClass: "single-email-container" }, [
                _c("div", { staticClass: "email-inputs-container" }, [
                  _c("div", { staticClass: "input-container" }, [
                    _c("p", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailAddress,
                          expression: "emailAddress"
                        }
                      ],
                      attrs: {
                        placeholder: "Enter single email address",
                        type: "email"
                      },
                      domProps: { value: _vm.emailAddress },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailAddress = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("p", [_vm._v("First Name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailFirstName,
                          expression: "emailFirstName"
                        }
                      ],
                      attrs: {
                        placeholder: "Enter recipient first name",
                        type: "string"
                      },
                      domProps: { value: _vm.emailFirstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailFirstName = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("p", [_vm._v("Last Name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailLastName,
                          expression: "emailLastName"
                        }
                      ],
                      attrs: {
                        placeholder: "Enter recipient last name",
                        type: "string"
                      },
                      domProps: { value: _vm.emailLastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailLastName = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("p", [_vm._v("From")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailFrom,
                          expression: "emailFrom"
                        }
                      ],
                      attrs: {
                        placeholder: "Enter sender name",
                        type: "string"
                      },
                      domProps: { value: _vm.emailFrom },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailFrom = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            : _c("div", { staticClass: "multiple-email-container" }, [
                _c("p", { staticClass: "main-subtitle small" }, [
                  _vm._v(
                    "Download our Bulk Recipient Email Template to upload your recipients. Don't worry, you only need their email address! "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "file-upload-container" }, [
                  _c("input", {
                    staticClass: "file-uploader",
                    attrs: { type: "file", accept: ".csv,.xlsx,.xls,.xlsb" },
                    on: { change: _vm.fileChange }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "download-template",
                    attrs: {
                      href:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Download our recipient email bulk template")]
                )
              ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "happybox-button yellow",
              attrs: { disabled: _vm.isValidEmail == false },
              on: { click: _vm.nextStep }
            },
            [_vm._v("Continue")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }